window.searchKeyFeaturesLengthCheck = function searchKeyFeaturesLengthCheck() {
    $('.js_keyFeatures').each(function () {
        if ($(this).find('li').length > 4 || matchesMediaQuery(0, 670)) {
            $(this).addClass('tooLong');
        }
    });
}

$(document).ready(function () {
    "use strict";

    $(document).on('click', '.js_viewMore', function(e) {
        e.preventDefault();
        $(this).toggleClass('active').closest('.itemDescription').find('.js_keyFeatures').toggleClass('show');
    });
});